export const MAIN_PAGE_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/inzhenernye-sistemy/';

export const MAIN_PAGE_CONSULTATION_SECTION_TITLE = 'Заявка на консультацию';

export const ENGINEERING_SYSTEMS_LANDING_NAME = 'engineering-systems';

export const ENGINEERING_SYSTEMS_CONSULTATION_TYPE = 'ENGINEERING';

export const SERVICE_ID_MAIN = '1530';
